import { ErrorDoggo } from '@/assets/svgAsComponents/error-doggo';
import { ErrorDoggoDark } from '@/assets/svgAsComponents/error-doggo-dark';
import { useContext } from 'react';
import { Button } from '../ui/button';
import { ThemeContext } from '@/context/theme-context';
import { SquaredBackground } from '../squared-background';
import { useTranslation } from 'react-i18next';
import { useMsalLogout } from '@/auth/use-msal-logout';
import { useLocation } from '@tanstack/react-router';

export const Error = () => {
  const { theme } = useContext(ThemeContext);
  const { t } = useTranslation();
  const logout = useMsalLogout();
  const location = useLocation();

  const isOnErrorRoute = location.pathname === '/error';

  return (
    <main className="min-h-screen min-w-full flex flex-col justify-center items-center text-center px-12 lg:px-0 relative isolate bg-background">
      <SquaredBackground />

      <div className="w-[200px] lg:w-[400px]">
        {theme == 'light' ? <ErrorDoggo /> : <ErrorDoggoDark />}
      </div>
      <h1 className="font-bold text-4xl pt-6 text-foreground">{t('error_page.title')}</h1>
      <h2 className="pt-2 text-secondary">{t('error_page.description')}</h2>

      {isOnErrorRoute ? (
        <>
          <p className="text-sm mt-8 text-secondary">{t('error_page.tryLogout4')}</p>
          <Button className="mt-4 px-12" onClick={logout} data-testid="logout-button">
            {t('error_page.logout_button')}
          </Button>
        </>
      ) : (
        <>
          <Button
            className="mt-8 px-12"
            onClick={() => {
              window.location.reload();
            }}
          >
            {t('error_page.refreshButton')}
          </Button>

          <p className="text-sm mt-4 text-secondary">
            {t('error_page.tryLogout1')}{' '}
            <span className="text-primary cursor-pointer hover:underline" onClick={logout}>
              {t('error_page.tryLogout2')}
            </span>{' '}
            {t('error_page.tryLogout3')}
          </p>
        </>
      )}
    </main>
  );
};
